import { Skeleton, Stack } from "@mui/material";

export const OptionsSkeleton = (): JSX.Element => {
  return (
    <Stack sx={{ p: 1 }}>
      {Array(3)
        .fill(1)
        .map((_, index) => (
          <Skeleton variant="text" key={index} />
        ))}
    </Stack>
  );
};
